module.exports = __webpack_public_path__ + "img/main_icon_badge_2k.7fbb9a6.png";